import { AnnualReportStep } from '@modeso/types__aumico-lib-annualreport-be';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';

export const NAVIGATION_TABS_MAP = new Map<
    string,
    {
        routerLink: string;
        tabLabelKey: string;
    }
>([
    [
        AnnualReportStep.GENERAL_INFORMATION,
        { routerLink: Paths.GENERAL_INFORMATION, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_GENRAL_INFORMATION },
    ],
    [
        AnnualReportStep.IMPORT_BALANCE_INCOME,
        { routerLink: Paths.IMPORT, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_IMPORT },
    ],
    [
        AnnualReportStep.FINANCIAL_CLOSING_PROCESS,
        { routerLink: Paths.FINANCIAL_CLOSING_PROCESS, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_CLOSING_PROCESS },
    ],
    [AnnualReportStep.CFS, { routerLink: Paths.CFS, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_CASH_FLOW }],
    [AnnualReportStep.NOTES, { routerLink: Paths.NOTES, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_NOTES_STEP }],
    [AnnualReportStep.AOP, { routerLink: Paths.AOP, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_AOP }],
    [
        AnnualReportStep.EMS,
        {
            routerLink: Paths.EQUITY_MOVEMENT_SCHEDULE,
            tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_EQUITY_MOVEMENT_SCHEDULE,
        },
    ],
    [
        AnnualReportStep.FAS,
        {
            routerLink: Paths.FAS,
            tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_FIXED_ASSETS_SCHEDULE,
        },
    ],
    [
        AnnualReportStep.ADJUSTMENTS_RECLASSIFICATION,
        {
            routerLink: Paths.ADJUSTMENTS_AND_RECLASSES,
            tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_ADJUSTMENTS_AND_RECLASSES,
        },
    ],
    [
        AnnualReportStep.CR,
        {
            routerLink: Paths.COMPLEMENTARY_REPORTS,
            tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_COMPLEMENTARY_REPORTS,
        },
    ],
    [
        AnnualReportStep.PRINT,
        { routerLink: Paths.PRINT, tabLabelKey: RouteLabels.FINANCIAL_STATEMENT_FINISH_AND_PRINT },
    ],
]);
